import {StyleSheet} from 'react-native';

import {alabaster} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: alabaster,
    padding: 0,
    paddingBottom: 0,
    maxWidth: '100%' as const,
    overflow: 'visible' as const,
    borderRadius: 8,
  },
  baseWithRoundedBottom: {
    overflow: 'hidden' as const,
  },
});
